import React from "react"
import LayoutDemolition from "../components/layout-demolition"
import PopularServices from '../components/popular-services'
import NearbyServices from '../components/nears-services'
import AnywereServices from '../components/anys-services'
// import ZipFinderKppDemolition from '../components/zip-finder-kpp-demolition'
import KppTips from "../components/kpptips"
import ProfilesCardsDemolition from "../components/profiles-cards-demolition"
import EmptyProfilesDemolition from "../components/empty-profiles-demolition"
import IconsKeywords from '../components/icons-keywords'
import Banner from "../components/banner"
import SidebarForm from "../components/sidebarForm"

const DemolitionKPP = ({ pageContext }) => {
    const cards = pageContext.cards
    const title = pageContext.title
    const profiles = pageContext.profiles.length > 0 ? pageContext.profiles[0] : []
    const env = pageContext.env
    const code = pageContext.code
    const codes = pageContext.codes.length > 0 ? pageContext.codes : []
    const populars = pageContext.populars.length > 0 ? pageContext.populars : []
    const nears = pageContext.nears;
    const anys = pageContext.anyweres;
    const icons = pageContext.icons;
    const tip = pageContext.tips.length > 0 ? pageContext.tips[0] : {}
    // const text = 'Find the right contractor to demolish and remove anything';
    const empty = profiles.length > 0 ? false : true

    const place =
    {
        name: pageContext.place.name,
        ht: pageContext.place.ht,
        state:
        {
            name: pageContext.place.state.name,
            av: pageContext.place.state.av,
            slug: pageContext.place.state.slug
        }
    }

    

    const seo_desc = pageContext.seo_desc
    const seo =
    {
        url: pageContext.url,
        env: env,
        place: place,
        code: code,
        page: pageContext.page,
        seo_desc: seo_desc,
        schema: pageContext.schemaOrg
    }

    return (
        <LayoutDemolition seo={seo} env={env} code={code} hidden={true} defaultStyles={{ maxWidth: '1920px', margin: 'auto', width: '100%' }} >
            <div className="top-kpp-container" >
                <div className="left-side-dumpster">
                    <Banner
                        code={code}
                        codes={codes}
                        env={env}
                        title={title}
                        url={pageContext.url}
                        place={place}
                        breadcrumb={true}
                    />
                    <div id="profiles-id-list" className="div d-none" data-htcode={code === 'demolition' ? 'demolition-contractors' : code}>{pageContext.pros}</div>
                    <IconsKeywords
                        icons={icons}
                        code={code}
                        codes={codes}
                        place={place}
                        url={pageContext.url}
                    />
                    {empty && <EmptyProfilesDemolition />}

                    {!empty && <ProfilesCardsDemolition profiles={profiles} code={code} place={place} cards={cards}/>}
                </div>
                <div className="col-4 view-prices-form fixed-right" >
                    <SidebarForm site={env.site} code={code}/>
                </div>
            </div>

            <div className="pt-5 pb-5 left-side-dumpster" >
                <div className="container ">
                    <div className="column">
                        {nears.length > 0 && <div className="col-md-12"><NearbyServices env={env} services={nears} place={place} code={code} codes={codes} /></div>}
                        {populars.length > 0 && <div className="col-md-12"><PopularServices env={env} services={populars} place={place} code={code} /></div>}
                        {anys.length > 0 && <div className="col-md-12"><AnywereServices env={env} services={anys} place={place} code={code} /></div>}
                    </div>
                </div>
            </div>

            <div className="container-fuild left-side-dumpster">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <KppTips tip={tip} codes={codes} code={code} place={place} />
                        </div>
                    </div>
                </div>
            </div>

        </LayoutDemolition>
    )
}

export default DemolitionKPP